// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_styles_btn-primary__3LMAq","multilineColumn":"_styles_multilineColumn__2Oahf","childOne":"_styles_childOne__3WLh_","childTwo":"_styles_childTwo__3VvNX"};